import moment from "moment";

const formatCouponExpiryDateTime = (endDateTime) => {
  if (!endDateTime) {
    return "";
  }

  const numericDateTime =
    typeof endDateTime === "string" && /^\d+$/.test(endDateTime)
      ? Number(endDateTime)
      : endDateTime;
  const parsedDateTime =
    typeof numericDateTime === "number"
      ? moment(
        numericDateTime < 100000000000
          ? numericDateTime * 1000
          : numericDateTime
      )
      : moment(numericDateTime, moment.ISO_8601, true);

  return parsedDateTime.isValid()
    ? parsedDateTime.format("DD MMM YYYY, h:mm A")
    : "";
};

export default formatCouponExpiryDateTime;